import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  height: 100%;
  width: 100%;

  h2 {
    margin: 0;
    padding: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--color-purple);
    margin-bottom: 4px;
    font-family: var(--font-display);
    text-align: left;
  }
`;

export const RulesList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 15px;
  padding: 0;

  strong {
    color: var(--color-purple);
    font-weight: 500;
  }
  li span {
    font-size: 14px;
  }
`;
